(() => {
  const scrollToReviews = () => {
    const selectors = [
      '.jdgm-rev-widg', '.spr-reviews', '.spr-container', '[data-reviews]', '[data-review-widget]',
      '.loox-reviews-default', '.okeReviews', '[id*="reviews"]', '[class*="reviews-widget"]',
      '.shopify-app-block'
    ];
    let target = null;
    for (const selector of selectors) {
      const nodes = Array.from(document.querySelectorAll(selector));
      target = nodes.find((node) => !node.closest('.vc-review-summary') && node.offsetParent !== null) || null;
      if (target) break;
    }
    if (!target) target = document.querySelector('.vc-review-summary');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-vc-review-jump]');
    if (!trigger) return;
    event.preventDefault();
    scrollToReviews();
  });
})();
